/**
 * One anchor for the whole chat dock: the launcher writes it when dragged, and
 * the panel reads it to open in the same place (and writes it back when moved).
 * Shared here rather than duplicated as a string literal in two files, because
 * a typo in one of them would silently split them apart again.
 */
export const CHAT_DOCK_ANCHOR_KEY = "chatDockAnchor";

/** Prefix for the panel's persisted width/height. */
export const CHAT_DOCK_SIZE_KEY = "chatDockPanel";
